import { RootState } from '../../../applicationStore';
import { OrderCounterState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getOrderCounterState = (state: RootState): OrderCounterState =>
  state.orderCounter;

export const getOrderCounterLoader = createSelector(
  getOrderCounterState,
  (state): boolean => state.loading,
);

export const getOrderCounterData = createSelector(
  getOrderCounterState,
  (state): OrderCounterState['data'] | null => state?.data || null,
);
